import { useEffect } from "react";
import * as Updates from "expo-updates";
import { Platform } from "react-native";

const useCheckUpdates = (shouldCheckForUpdate: boolean) => {
  const { isUpdateAvailable, isUpdatePending } = Updates.useUpdates();

  useEffect(() => {
    if (Platform.OS === "web") return;
    if (shouldCheckForUpdate) {
      Updates.checkForUpdateAsync().catch(() => {});
    }
  }, [shouldCheckForUpdate]);

  useEffect(() => {
    if (Platform.OS === "web") return;
    if (isUpdateAvailable) {
      Updates.fetchUpdateAsync().catch(() => {});
    }
  }, [isUpdateAvailable]);

  useEffect(() => {
    if (Platform.OS === "web") return;
    if (!isUpdatePending) return;
    // Defer one tick so in-flight screens/reanimated fragment ops drain
    // before the React host is destroyed (avoids "Fragment already added"
    // crash in com.swmansion.rnscreens.ScreenContainer.removeMyFragments).
    const id = setTimeout(() => {
      Updates.reloadAsync().catch(() => {});
    }, 150);
    return () => clearTimeout(id);
  }, [isUpdatePending]);
};

export default useCheckUpdates;
